import type { ReleaseStage } from 'src/components/Chips/ReleaseChip';
import SimpleIconsLinear from '~icons/simple-icons/linear';
import SimpleIconsPagerduty from '~icons/simple-icons/pagerduty';
import SimpleIconsSlack from '~icons/simple-icons/slack';
import TablerIconCode from '~icons/tabler/code';
import TablerIconDocs from '~icons/tabler/file-type-doc';
import TablerIconFolder from '~icons/tabler/folder';
import TablerIconWorld from '~icons/tabler/world';

export type ChatContextOptionId = (typeof chatContextOptions)[number]['value'];

export interface ChatContextOption extends BaseChatContextOption {
  /**
   * The value of the option.
   */
  value: ChatContextOptionId;
}

/**
 * The available chat context options.
 */
export const chatContextOptions = [
  {
    label: 'Code Files',
    icon: <TablerIconCode />,
    value: 'code',
    status: 'alpha',
    keywords: [
      'code',
      'codebase',
      'codebases',
      'codebase',
      'file',
      'files',
      'directory',
      'directories',
      'dir',
      'folder',
    ],
  },
  {
    label: 'Joggr Docs',
    icon: <TablerIconDocs />,
    value: 'docs',
    status: 'soon',
    keywords: ['docs', 'documentation', 'documentation', 'documentation'],
  },
  {
    label: 'Joggr Directories',
    icon: <TablerIconFolder />,
    value: 'directories',
    status: 'soon',
    keywords: ['directories', 'directory', 'dir', 'folder'],
  },
  {
    label: 'Slack',
    icon: <SimpleIconsSlack />,
    value: 'slack',
    status: 'soon',
    keywords: ['slack', 'slack', 'slack', 'slack'],
  },
  {
    label: 'Linear',
    icon: <SimpleIconsLinear />,
    value: 'linear',
    status: 'soon',
    keywords: ['linear', 'linear', 'linear', 'linear'],
  },
  {
    label: 'Pagerduty',
    icon: <SimpleIconsPagerduty />,
    value: 'pagerduty',
    status: 'soon',
    keywords: ['pagerduty', 'pagerduty', 'pagerduty', 'pagerduty'],
  },
  {
    label: 'Web',
    icon: <TablerIconWorld />,
    value: 'web',
    status: 'soon',
    keywords: ['web', 'web', 'web', 'web'],
  },
] as const satisfies BaseChatContextOption[];

interface BaseChatContextOption {
  /**
   * The label of the option.
   */
  label: string;
  /**
   * The icon of the option.
   */
  icon: React.ReactNode;
  /**
   * The value of the option.
   */
  value: string;
  /**
   * The status of the option.
   */
  status: ReleaseStage | 'soon';
  /**
   * The search keywords for the option.
   */
  keywords: string[];
}
